<template>

    <div id="agree">
        <el-button size="medium" @click="exportPDF" type="danger" class="export">导出</el-button>
        <div class="topic-title">自由职业者服务协议</div>

        <div class="name-head">
            <div class="clause-content name-head-a">甲方：<span>{{channel_name}}</span></div>
            <div class="clause-content name-head-b">乙方：<span>{{fullname}}</span></div>
        </div>
        <div class="tips-clause">提示条款：</div>
        <div class="clause-content">欢迎乙方以本人注册的个体工商户（下称“乙方”）与我司（下称“甲方”）签署本《自由职业者服务协议》（下称“本协议”），并为甲方的合作公司提供服务。</div>
        <div class="tips tips-key">
            【审慎阅读】为维护乙方的自身权益，在乙方点击同意或书面签署本协议之前，请认真阅读本协议，务必审分理解各条款内容，特别是权利义务条款、法律适用和管辖条款。上述条款以粗体及下划线标识，乙方应重点阅读。</div>
        <div class="tips tips-key">
            【签约】当乙方按照提示填写乙方经营者的个人信息、上传乙方的营业执照、阅读并同意本协议且完成全部申请或书面签署后，即表示乙方已充分阅读、理解并接受本协议的全部内容，并与甲方达成一致意见并成为甲方的合作人员（以个体工商户名义开展合作），此后乙方不得以未阅读/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果乙方不同意本协议或其中任何条款约定，请乙方立即停止任何的申请/注册/或书面签署程序。
        </div>
        <div class="tips tips-key">
            【合作关系】乙方与甲方通过本协议建立合作关系，适用《中华人民共和国民法典》和其他民事法律，不适用《中华人民共和国劳动法》。
        </div>
        <div class="clause-title">协议条款：</div>
        <div class="terms">根据国家法律有关规定，双方按照平等自愿、诚实信用的原则，就乙方通过甲方为合作公司提供【 {{channel_name}} 】服务事宜订立本服务合作协议。</div>
        <div class="clause">
            <div class="clause-title">第一条 服务工作内容</div>
            <div class="clause-content">
                1.1 因甲方与合作公司服务合作需要，特选用乙方按照甲方与合作公司相关合同的规定提供【 {{category_name}} 】服务。
            </div>
            <div class="clause-content">1.2 乙方应按照甲方与合作公司相关合同要求规定的标准完成工作。</div>
            <div class="clause-content">
                1.3 乙方承诺和保证，乙方具有提供本协议服务所对应的相应资质和专业能力，乙方依据本合同约定收取相关费用不违反任何法律法规和政策规定。
            </div>
        </div>
        <div class="clause">
            <div class="clause-title">第二条 协议效力</div>
            <div class="clause-content key">2.1
                乙方的签约信息（包括乙方经营者的姓名、身份证号、营业执照等信息），以乙方提供的信息为准（包括但不限于线上提供或线下提供）。乙方承诺并保证乙方所提供的签约信息真实、准确，以免影响乙方和甲方之间的《服务合作协议》效力。本协议条款若在甲方授权的网站上发布，自乙方线上点击确认之日起生效；若为书面签署，自乙方签署本协议之日起生效。
            </div>
            <div class="clause-content">2.2
                本协议自签订之日起一年内有效。期限届满，双方应另行签署新的协议；若双方未签署新的协议，而以实际行动继续合作的，视为双方同意协议期限顺延直至按照本协议约定终止或解除时为止。</div>
            <div class="clause-content">2.3 本协议在发生下列情形时自然终止：</div>
            <div class="clause-content-content">a、 甲方认为乙方不适合继续提供服务的；</div>
            <div class="clause-content-content">b、 甲方和合作公司解除合作的；</div>
            <div class="clause-content-content">c、 其他原因导致本协议不再继续履行的。</div>
        </div>
        <div class="clause">
            <div class="clause-title">第三条 甲方的权利和义务</div>
            <div class="clause-content key third">3.1 乙方应根据甲方的安排为合作公司提供服务，服务期间乙方应遵守甲方与合作公司共同确定的有关服务内容、服务质量等方面的要求。</div>
            <div class="clause-content">3.2 甲方根据与合作公司约定的相关标准对乙方提供服务的工作成果进行验收。</div>
            <div class="clause-content key">3.3 甲方应按约定及时向乙方支付费用。</div>
            <div class="clause-content">3.4
                乙方同意，乙方不可撤销地授权甲方有权为提供前述服务的需要获取乙方的相关信息，包括但不限于经营者个人身份信息、实名登记手机号码、银行账户相关信息等，并将乙方的相关信息提交到第三方机构进行身份验证。若乙方提供任何错误、虚假、失效或不完整的资料，或者甲方有合理的理由怀疑资料为错误、虚假、过期或不完整，甲方有权暂停或终止向乙方提供部分或全部服务，对此甲方不承担任何责任，乙方承诺并同意负担因此所产生的所有损失，包括但不限于直接损失、间接损失。若因国家法律法规、部门规章或监管机构的要求，甲方需要乙方补充提供任何相关资料时，如乙方不能及时配合提供，甲方有权暂停或终止向乙方提供部分或全部服务。
            </div>
        </div>
        <div class="clause">
            <div class="clause-title">第四条 乙方的权利和义务</div>
            <div class="clause-content">&nbsp;&nbsp;&nbsp;&nbsp;4.1
                乙方应按时尽责地完成甲方要求的工作内容，并达到规定的质量标准，不得有侵犯他人知识产权、财产权、人身权、肖像权、隐私权、商业秘密或其他合法权益以及其他违反国家法律法规、国家政策、或有悖于公序良俗的内容。否则，因此导致甲方遭受损失的（包括但不限于行政处罚、民事责任、刑事责任），均由乙方承担全部赔偿责任，同时甲方有权选择解除本协议。
            </div>
            <div class="clause-content key">4.2
                协议期内，乙方应在甲方许可范围内使用本合同有关的商业信息；协议期内以及协议终止后，乙方均有义务对双方合作的有关协议及合作过程中知悉的甲方、合作公司的相关信息予以保密，未经书面许可，乙方不得以任何方式向其它方披露、给予或转让该等保密信息。否则，因此导致甲方及/或合作公司或其关联公司的损失，由乙方负责赔偿。
            </div>
            <div class="clause-content">4.3 除本协议事项外，乙方不能以甲方及/或合作公司的名义开展任何与完成约定的工作任务无关的业务或活动。</div>
            <div class="clause-content">4.4
                若相关服务通过甲方指定的网络平台提供或备案，该网络平台可能要求乙方或乙方经营者签署、点击电子协议，乙方或乙方经营者同意点击签署。乙方或乙方经营者点击确认后该协议将对乙方产生法律效力。
            </div>
        </div>
        <div class="clause">
            <div class="clause-title">第五条 服务费用的支付</div>
            <div class="clause-content">
                5.1．根据甲方与其合作公司之间签署的《共享经济智能综合服务协议》的规定，甲方应就其向合作公司提供的共享经济综合服务收取服务费，其中，服务费金额中涵盖最终对应到乙方基于其自由职业者活动而取得的费用金额，甲方将完税后金额支付予乙方。
            </div>
            <div class="clause-content key">5.2．关于服务费具体结算及支付方式，参见附件一。</div>
            <div class="clause-content key">5.3．乙方应自行负担就其取得的服务费需缴纳的行政收费（如有）。</div>
            <div class="clause-content key">5.4．乙方应向甲方提供以乙方经营者本人实名注册的对应账户信息，以及相关必要的证件。若具体账户信息在指定的网络平台在线提供的，以乙方在线提供的信息为准。
            </div>
            <div class="clause-content">5.5
                甲方服务费用支付以乙方提供的收款帐户为准，因乙方提供的收款帐户不实造成的一切损失由乙方自行承担。如乙方帐号变更或发生不可用等情况时，应及时书面通知甲方，否则，由此造成的一切损失由乙方自行负责。</div>
            <div class="clause-content key">5.6 甲方不承担乙方经营者任何社保福利待遇，也不负责乙方经营者的任何医疗保险费用。</div>
        </div>
        <div class="clause">
            <div class="clause-title six">第六条 违约责任</div>
            <div class="clause-content">6.1 双方应按本协议约定履行，如有违反，守约方有权要求对方及时改正；造成对方损失的，守约方有权要求违约方赔偿。</div>
            <div class="clause-content">6.2
                因不可抗力造成损失的，彼此不负赔偿责任，但发生不可抗力一方应及时将有关情况通知另一方，并尽最大努力进行补救。本协议所称不可抗力是指不能预见、不能克服并不能避免且对一方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、火灾和风暴等以及社会事件如战争、动乱、政府行为、黑客事件、大范围电信事故等。
            </div>
        </div>
        <div class="clause">
            <div class="clause-title">第七条 协议的终止</div>
            <div class="clause-content">7.1 发生以下情形时，本协议终止：</div>
            <div class="clause-content-content">a. 协议期限届满；</div>
            <div class="clause-content-content">b. 一方违反协议约定，且违约方在非违约方书面通知后15日内仍未予改正的，非违约方可以书面通知的形式终止本协议；</div>
            <div class="clause-content-content">c. 乙方如未能达到甲方的要求，甲方在工作验收时将给予警告；此后如仍发生类似情况的，甲方可提前终止本协议。</div>
            <div class="clause-content">7.2 本协议的提前终止不影响已经产生的权利义务关系。</div>
        </div>
        <div class="clause">
            <div class="clause-title">第八条 涉税事务委托授权</div>
            <div class="clause-content">8.1
                乙方委托甲方代理本合同交易项下的涉税事务,包括代理报税、代开发票和代开个人完税证明。甲方在向乙方支付服务费时，有权按照有关税收政策规定及甲方主管税务机关的要求，向其代征个人所得税等税款及行政收费（如有），该等款项将从企业客户所支付的服务费中予以扣减。应甲方要求，乙方应提供与税款申报缴纳相关的协助及信息。
            </div>
            <div class="clause-content">
                8.2 乙方确认甲方根据本合同授权提交的相关申报资料和信息是真实、完整、准确，和符合有关法律法规的。
            </div>
            <div class="clause-content">8.3 乙方确认乙方经营者与甲方的合作公司不存在法律上和事实上的人事劳动关系，不属于合作公司人事管理权限范围内的个人，也并非其股东。
            </div>
        </div>
        <div class="clause">
            <div class="clause-title">第九条 其他</div>
            <div class="clause-content key">9.1 因履行本协议发生的纠纷，双方应友好协商解决，协商不成的，提请至甲方所在地仲裁委员会按照其仲裁规则仲裁解决。</div>
            <div class="clause-content">9.2 甲方有权根据业务需要修改本协议条款。</div>
            <div class="clause-content key">（以下无正文）</div>
            <div class="both-sides">
                <div class="party-a">
                    <div class="bb-wrapper">甲方：<span>{{channel_name}}</span></div>
                    <div class="bb-wrapper">授权代表人：<span>{{channel_deputy}}</span></div>
                    <div class="bb-wrapper">签署日期：<span>{{created_at}}</span></div>
                </div>
                <div class="party-b">
                    <div class="bb-wrapper">乙方：<span>{{fullname}}</span></div>
                    <!-- <div class="bb-wrapper">身份证号码：<span>{{id_number}}</span></div> -->
                    <!-- <div class="bb-wrapper">授权代表人：<span>{{full_deputy}}</span></div> -->
                    <div class="bb-wrapper">
                        <div>授权代表人：</div>
                        <!-- <img id="autograph" src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/xlh5/customer/1595236416626.2603.png"
                      data-imgUrl="http://fastmarket.oss-cn-shenzhen.aliyuncs.com/oss/static/other/1/images/baseMap_index.jpg"/> -->
                        <img id="autograph" :src="this.sign_url" v-if="this.sign_url" :data-imgUrl="this.sign_url" />
                        {{ this.sign_url ? "" : this.full_deputy }}
                    </div>
                    <div class="bb-wrapper">签署日期：<span>{{created_at}}</span></div>
                </div>
            </div>
        </div>
        <div>
            <div class="enclosure">附件一 服务费的结算及支付规则</div>
            <div class="clause-content">就本协议第五条规定的服务费的具体支付及结算方式，双方应按照下列规则进行执行：</div>
            <div class="clause-content-content">⦁
                根据甲方与其合作公司签署的《共享经济智能综合服务协议》的规定，对于乙方向甲方合作公司提供的生产经营活动，甲方合作公司在向甲方结算服务费（简称“服务费”）时，将按照业务结算规则计算最终对应到乙方的服务费。
            </div>
            <div class="clause-content-content">⦁ 甲方在收取服务费后将向乙方支付服务费，具体应支付至甲方合作公司提供的提现申请单上列示的乙方收款账户。
            </div>
            <div class="clause-content-content">⦁ 本协议对服务费的结算周期不作明确约定，视具体活动内容及需求，双方可自行协商。</div>
        </div>
    </div>
</template>

<script>
    import html2Canvas from "html2canvas";
    import JsPDF from "jspdf";
    export default {
        name: "SubExportPdf",
        data() {
            return {
                channel_deputy: "",
                full_deputy: "",
                category_name: "",
                channel_name: "",
                company_name: "",
                created_at: "",
                sign_url: "",
                fullname: "",
                id_number: "",
            };
        },
        created() {
            //设置跳转后滚动条默认为0
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            this.category_name = this.$route.query.category_name;
            this.channel_name = this.$route.query.channel_name;
            this.company_name = this.$route.query.company_name;
            this.channel_deputy = this.$route.query.channel_deputy;
            this.full_deputy = this.$route.query.full_deputy;
            this.created_at = this.$route.query.created_at.split(" ")[0];
            // this.sign_url = `https://xl-online.oss-cn-hangzhou.aliyuncs.com/xlh5/customer/1595236416626.2603.png`
            this.sign_url = this.$route.query.sign_url;
            this.id_number = this.$route.query.id_number;
            this.fullname = this.$route.query.fullname;
        },
        methods: {
            exportPDF() {
                const title = "自由职业者协议";
                this.getPdf(title);
            },
            getPdf(title) {
                const opts = {
                    scale: 2,
                    dpi: window.devicePixelRatio * 4,
                    useCORS: true,
                    allowTaint: true, //允许加载跨域的图片
                    tainttest: true, //检测每张图片都已经加载完成
                    logging: false, //日志开关，发布的时候记得改成false
                };
                var canvas = document.createElement("canvas"),
                    // url = `https://xl-online.oss-cn-hangzhou.aliyuncs.com/xlh5/customer/1595236416626.2603.png`,
                    url = this.sign_url,
                    ctx = canvas.getContext("2d"),
                    img = new Image();
                img.crossOrigin = "Anonymous"; // 重点！设置image对象可跨域请求
                img.src = url + "?timeStamp=" + new Date().getTime(); //解决缓存引起访问失败需要添加时间戳。。。。。问题的关键点
                console.log(url, "链接")
                if (url) {
                    img.onload = function() {
                        canvas.height = img.height;
                        canvas.width = img.width;
                        ctx.drawImage(img, 0, 0);
                        // 将canvas的透明背景设置成白色
                        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        for (var i = 0; i < imageData.data.length; i += 4) {
                            // 当该像素是透明的，则设置成白色
                            if (imageData.data[i + 3] == 0) {
                                imageData.data[i] = 255;
                                imageData.data[i + 1] = 255;
                                imageData.data[i + 2] = 255;
                                imageData.data[i + 3] = 255;
                            }
                        }
                        ctx.putImageData(imageData, 0, 0);
                        var dataURL = canvas.toDataURL("image/jpeg");
                        document.getElementById("autograph").setAttribute("src", dataURL);
                        html2Canvas(document.getElementById("agree"), opts).then(function(
                            canvas
                        ) {
                            console.log(canvas, "canvasa");
                            let contentWidth = canvas.width;
                            let contentHeight = canvas.height;
                            let pageHeight = (contentWidth / 592.28) * 841.89;
                            let leftHeight = contentHeight;
                            let position = 0;
                            let imgWidth = 595.28;
                            let imgHeight = (592.28 / contentWidth) * contentHeight;
                            let pageData = canvas.toDataURL("image/jpeg", 1.0);
                            let PDF = new JsPDF("", "pt", "a4");
                            if (leftHeight < pageHeight) {
                                PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                            } else {
                                while (leftHeight > 0) {
                                    PDF.addImage(
                                        pageData,
                                        "JPEG",
                                        0,
                                        position,
                                        imgWidth,
                                        imgHeight
                                    );
                                    leftHeight -= pageHeight;
                                    position -= 841.89;
                                    if (leftHeight > 0) {
                                        PDF.addPage();
                                    }
                                }
                            }
                            // var blob = PDF.output("blob");
                            // window.open(URL.createObjectURL(blob));
                            PDF.save(title + ".pdf");
                        });
                    };
                } else {
                    html2Canvas(document.getElementById("agree"), opts).then(function(
                        canvas
                    ) {
                        console.log(canvas, "canvasb");
                        let contentWidth = canvas.width;
                        let contentHeight = canvas.height;
                        let pageHeight = (contentWidth / 592.28) * 841.89;
                        let leftHeight = contentHeight;
                        let position = 0;
                        let imgWidth = 595.28;
                        let imgHeight = (592.28 / contentWidth) * contentHeight;
                        let pageData = canvas.toDataURL("image/jpeg", 1.0);
                        let PDF = new JsPDF("", "pt", "a4");
                        if (leftHeight < pageHeight) {
                            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                        } else {
                            while (leftHeight > 0) {
                                PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                                leftHeight -= pageHeight;
                                position -= 841.89;
                                if (leftHeight > 0) {
                                    PDF.addPage();
                                }
                            }
                        }
                        // var blob = PDF.output("blob");
                        // window.open(URL.createObjectURL(blob));
                        PDF.save(title + ".pdf");
                    });
                }
            },
        },
    }
</script>

<style scoped lang="stylus">
    .name-head {
        margin: 20px 0;
    }

    .name-head-a {
        margin: 15px 0;
    }

    .name-head-b {
        margin: 15px 0;
    }

    .export {
        position: absolute;
        top: 20px;
        right: 40px;
    }

    #agree {
        color: #000;
        width: 596px;
        margin: 0 auto;
        padding: 0 60px;
        background: #fff;
    }

    .topic-title {
        display: block;
        text-align: center;
        padding: 20px 0;
        font-weight: bolder;
        font-size: 18pt;
    }

    .tips-clause {
        padding: 10px 0;
        font-weight: bolder;
        font-size: 9pt;
        text-indent: 2em;
    }

    .tips {
        padding: 10px 0;
        font-size: 9pt;
        font-weight: bolder;
        line-height: 20px;
        text-indent: 2em;
    }

    .tips-key {
        /* text-decoration: underline; */
    }

    .terms {
        padding-top: 20px;
        padding-bottom: 10px;
        font-size: 9pt;
        line-height: 20px;
        text-indent: 2em;
    }

    .clause {
        padding: 10px 0;
    }

    .clause-title {
        margin-top: 15px;
        font-weight: bolder;
        font-size: 9pt;
        color: #000;
        text-indent: 2em;
    }

    .clause-content,
    .clause-content-content {
        padding: 10px 0;
        font-size: 9pt;
        line-height: 20px;
    }

    .clause-content-content {
        margin-left: 20px;
    }

    .enclosure {
        text-align: center;
        font-weight: bolder;
        margin: 60px 0 50px 0;
        font-size: 9pt;
    }

    .sign-company {
        margin-top: 30px;
        padding: 20px 0;
    }

    .key {
        font-weight: bolder;
        /* text-decoration: underline; */
    }

    .close {
        margin-bottom: 30px;
    }

    .btn-row {
        margin-top: 10px;
        padding: 0 10px;
    }

    .both-sides {
        font-size: 9pt;
        margin-top: 20px;
        overflow: hidden;
    }

    .party-a {
        float: left;
        width: 200px;
        line-height: 30px;
    }

    .party-b {
        line-height: 30px;
        float: left;
        margin-left: 150px;
    }

    .bb-wrapper {
        font-size: 9pt;
        margin-top: 15px;
        overflow: hidden;
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    #autograph {
        width: 100px;
        height: 100px;
    }
</style>
